import * as yup from "yup";

export const AddressSchema = yup.object().shape({
	firstName: yup.string().required("First name is required"),
	lastName: yup.string().required("Last name is required"),
	phone: yup.string().required("Phone is required"),
	addressLine1: yup.string().required("Address is required"),
	city: yup.string().required("City is required"),
	countryId: yup.string().required("Country is required"),
	stateId: yup.string().required("State is required"),
	zipCode: yup.string().required("Zip Code is required"),
});

export const ShippingSchema = yup.object().shape({
	address: AddressSchema,
});

export const addressDefaultValues = {
	firstName: "",
	lastName: "",
	phone: "",
	addressLine1: "",
	addressLine2: "",
	city: "",
	countryId: "",
	stateId: "",
	zipCode: "",
};
